
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Row, Col, Button, Divider, Dropdown, Menu, message, Modal } from 'antd';
import './style.css';

// Actions
import { save_company, get_company, delete_company, get_company_by_id, edit_company } from './actions/company.action';

// Childe Components
import NewCompany from './childs/new.company';
import EditCompany from './childs/edit.company';

const confirm = Modal.confirm;
class Company extends Component {

    constructor( props ){
        super( props );

        this.state = {
            new_company_modal: false,
            edit_company_modal: false,
            company_id: '',
            data: [],
            edit_data: []
        }

        this.handleController = this.handleController.bind( this );
        this.handleNewCompany = this.handleNewCompany.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleSubmitEdit = this.handleSubmitEdit.bind( this );

    }

    handleController( e ){
        
        let self = this;

        if( e.key === '1' ){
            this.props.get_company_by_id( e.item.props.id );
        } else if( e.key === '2' ){
            
            confirm({
                title: 'Do you Want to delete This Company?',
                onOk() {
                    self.props.delete_company( e.item.props.id );
                },
                onCancel() {
                    // Nothing
                },
            });

        }
    }

    handleNewCompany(){
        this.setState({ new_company_modal: true, edit_company_modal: false })
    }

    handleSubmit( data ){
        this.props.save_company( data );

        this.setState({
            new_company_modal: false
        })
    }

    handleSubmitEdit( data ){
        this.props.edit_company( data );

        this.setState({
            edit_company_modal: false
        })
    }

    componentWillMount(){
        this.props.get_company();
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.company.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }
        
        // Start

        if( nextProps.company.STATUS.CODE === "200" && 
            nextProps.company.STATUS.MESSAGE === "Successfully Saved Company" ) {
            message.success('Successfully Saved Company Profile');
            this.props.get_company();

            this.setState({
                new_company_modal: false,
                edit_company_modal: false,
            })
            
        } else if ( nextProps.company.STATUS.CODE === "200" && 
            nextProps.company.STATUS.MESSAGE === "Successfully Listed Company" ) {
            this.setState({
                data: nextProps.company.OUTPUT.DATA,
                new_company_modal: false,
                edit_company_modal: false,
            });

        } else if ( nextProps.company.STATUS.CODE === "200" && 
            nextProps.company.STATUS.MESSAGE === "Successfully Deleted Company" ) {
            message.success('Successfully Deleted Company Profile');
            this.props.get_company();

            this.setState({
                new_company_modal: false,
                edit_company_modal: false,
            })

        } else if ( nextProps.company.STATUS.CODE === "200" && 
            nextProps.company.STATUS.MESSAGE === "Successfully Listed By ID" ) {
            
            this.setState({
                edit_data: nextProps.company.OUTPUT.DATA,
                edit_company_modal: true,
                new_company_modal: false,
            });

        } else if ( nextProps.company.STATUS.CODE === "200" && 
            nextProps.company.STATUS.MESSAGE === "Successfully Updated Company" ) {
            
            message.success('Successfully Updated Company Profile');
            this.props.get_company();

            this.setState({
                new_company_modal: false,
                edit_company_modal: false,
            })

        } else if ( nextProps.company.STATUS.CODE === "400" ) {

            message.error( nextProps.company.STATUS.MESSAGE );

            this.setState({
                new_company_modal: false,
                edit_company_modal: false,
            })
            
        }

        // End

    }

    render() {

        const company_list = this.state.data.map( (item, i) => <li key={ i } className="list">
            <Dropdown overlay={ <Menu onClick={ this.handleController }>
                <Menu.Item key="1" id={ item.company_id } ><Icon type="edit" />Edit &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                <Menu.Item key="2" id={ item.company_id } ><Icon type="delete" />Delete &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                </Menu> } trigger={['click']}>
                <span className="control"><Icon type="ellipsis" /></span>
            </Dropdown>

            <h3>{ item.company_name }</h3>
            <p>{ item.company_address }</p>
        </li> );

        return (
            <div className="company_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="home" />
                            &nbsp; Company Profile
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ this.handleNewCompany }
                            className="fl_right" type="primary" icon="plus">Add Company Profile</Button>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <ul className="company_list">
                            { company_list }
                        </ul>
                    </Col>
                </Row>

                
                <NewCompany onSubmit={ this.handleSubmit } onModel={ this.state.new_company_modal } />
                <EditCompany onSubmit={ this.handleSubmitEdit } onModel={ this.state.edit_company_modal } data={ this.state.edit_data } />

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        company: state.company
    }
}

export default connect( mapStatetoProps, { save_company, get_company, delete_company, get_company_by_id, edit_company } )( Company );



// WEBPACK FOOTER //
// ./src/pages/company/index.js